import { Image, Info } from 'components';

export default function ResultsInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person standing under a magnifying glass with green checkmarks and red crosses swirling" path="results.png" title="Results" />
        <h5>Results</h5>
        <p>
            This is the actual result of the experiment. This calculator can only be used for binary (yes/no) results.
            <br/>
            <br/>
            <span className="fw-bold">Example:</span> If you count 24 people who order a milkshake at a restaurant and 176 people who do not, that is a binary result. You can enter the results as either the number 24 <span className="text-decoration-underline">or</span> enter the percentage 12%.
            <br/>
            <br/>
            If you asked people on a survey to rate something from 1-5 stars, do <span className="text-decoration-underline">not</span> use this calculator to find the average rating. But you <span className="text-decoration-underline">could</span> use this calculator to calculate the % of people who rate something 5 stars.
        </p>
    </Info>;

}